<template>
  <div>
    <div
      class="tab-pane resource-container tab-pane p-tablet-0"
      role="tabpanel"
    >
      <CCard class="card-table-emloyee">
        <CRow>
          <CCol class="search-mb-info" sm="4">
            <div class="form-group">
              <label>{{
                  $t(
                    "placeholder.label_employee_over_time_request_search_code_name"
                  )
                }}</label>
              <CInput
                v-model="searchData.info"
                :placeholder="
                      this.$t(
                        'placeholder.label_employee_over_time_request_search_code_name'
                      )
                    "
                v-on:focusout="checkId()"
                v-on:keyup.enter="search"
              />
            </div>
          </CCol>
          <CCol sm="4">
            <div class="form-group mb-mobile-2">
              <label>{{ $t("employee.label_employee_foot") }}</label>
              <select
                v-model="searchData.footCode"
                class="form-control"
                @change="search"
              >
                <option value="0">
                  {{ $t("placeholder.label_employee_option_search") }}
                </option>
                <option
                  v-for="(item, index) in footOptions"
                  :key="index"
                  :value="item.code"
                >{{ item.name }}
                </option
                >
              </select>
            </div>
          </CCol>
          <CCol sm="4">
            <div class="form-group mb-mobile-2">
              <label>{{ $t("employee.label_employee_division") }}</label>
              <select
                v-model="searchData.division"
                class="form-control"
                @change="search"
              >
                <option value="0">
                  {{ $t("placeholder.label_employee_option_search") }}
                </option>
                <option
                  v-for="(item, index) in footDivision"
                  :key="index"
                  :value="item.code"
                >{{ item.name }}
                </option
                >
              </select>
            </div>
          </CCol>
        </CRow>
        <span class="mb-4"></span>
        <CRow>
          <CCol class="search-mb-info" sm="4">
            <div class="form-group">
              <label>{{ $t("project.label_project_skill") }}</label>
              <select
                v-model="searchData.skill"
                class="form-control"
                @change="search"
              >
                <option value="0">
                  {{ $t("project.label_project_default_option") }}
                </option>
                <option
                  v-for="(item, index) in skillLv2"
                  :key="index"
                  :value="item.code"
                >{{ item.name }}
                </option
                >
              </select>
            </div>
          </CCol>
          <CCol sm="4">
            <div class="form-group mb-mobile-2">
              <label>{{ $t("commons.label_week") }}</label>
              <DatePicker
                v-model="currentDate"
                :clearable="false"
                :lang="fisrtDay"
                :show-week-number="false"
                format="DD/MM/YYYY"
                range
                type="date"
                value-type="date"
              >
                <template slot="input">
                  <input
                    :style="{ fontWeight: 400 }"
                    :value="`${searchData.startDate} ~ ${searchData.endDate}`"
                    class="date-input"
                    disabled
                  />
                </template>
              </DatePicker>

            </div>
          </CCol>
          <CCol sm="4">
            <div class="form-group mb-mobile-2">
              <label> {{ $t("employee.label_employee_status") }}</label>
              <select
                v-model="searchData.status"
                class="form-control"
                @change="search"
              >
                <option value="0">
                  {{ $t("placeholder.label_employee_option_search") }}
                </option>
                <option
                  v-for="(item, index) in statusOptions"
                  :key="index"
                  :value="index + 1"
                >{{ item }}
                </option
                >
              </select>
            </div>
          </CCol>
        </CRow>
        <span class="mb-4"></span>
        <CRow>
          <CCol sm="4">
            <div class="form-group mb-mobile-2">
            </div>
          </CCol>
          <CCol class="btn-search text-center" sm="4">
            <CButton class="btn-search-employee" @click.prevent="search">
              {{ $t("button.label_employee_btn_search") }}
            </CButton>
            <CButton class="btn-reset" @click="resetForm">{{
                $t("button.label_action_reset")
              }}
            </CButton>
          </CCol>
          <CCol sm="4">
            <div class="form-group mb-mobile-2">
            </div>
          </CCol>
        </CRow>
      </CCard>
      <CRow>
        <CCol sm="12">
          <CCard class="employee-table">
            <CCardBody>
              <div class="table-responsive">
                <table class="table-list-employee">
                  <thead>
                  <tr class="tr-lable">
                    <th class="border-top-left">#</th>
                    <th scope="col">
                      {{ $t("employee.label_employee_name") }}
                    </th>
                    <th scope="col">
                      {{ $t("employee.label_employee_division") }}
                    </th>
                    <th scope="col">
                      {{ $t("employee.label_employee_position") }}
                    </th>
                    <th scope="col">
                      {{ $t("project.label_resource_situation_detail") }}
                    </th>
                    <th scope="col">
                      {{ $t("project.label_project_skill") }}
                    </th>
                    <th class="w-95" scope="col">
                      {{ $t("project.label_project_status") }}
                    </th>
                    <th class="w-95 border-top-right" scope="col">
                      {{ $t("project.label_project_action") }}
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <template
                    v-if="
                            resourceSituations &&
                              resourceSituations.length > 0
                          "
                  >
                    <tr
                      v-for="(item, index) in resourceSituations"
                      :key="index"
                    >
                      <td scope="row">{{ (page - 1) * 10 + index + 1 }}</td>
                      <td>{{ item.name }} - {{ item.id }}</td>
                      <td>{{ item.department.name }}</td>
                      <td>{{ item.position.name === 'Comtor' ? 'BrSe' : item.position.name }}</td>
                      <td v-if="" class="text-left">
                        <div :class="{'overflow-project-detail': item.details.length > 5}">
                          <template v-if="item.effortEmployee > 0">
                            <li
                              v-for="(item1, index1) in item.details"
                              v-if="item.details && item.details.length > 0"
                              :key="index1"
                            >
                                  <span
                                  >-
                                    {{
                                      $t(
                                        "project.label_resource_situation_project_title"
                                      )
                                    }}: </span
                                  >{{ item1.project_name }}
                            </li>
                          </template>
                        </div>
                        <template v-if="item.effortEmployee == 0">
                          <li>
                                  <span>-
                                    {{
                                      $t(
                                        "project.label_resource_situation_project_title"
                                      )
                                    }}: </span
                                  >{{ item.lastProject[0] ? item.lastProject[0].project_name : '' }} (
                            {{ item.lastProject[0] ? formatDate(item.lastProject[0].member_project_end_date) : '' }} )
                          </li>
                        </template>
                      </td>
                      <td>
                        <div :class="{'overflow-project-detail': item.employee_skill.length > 5}">
                          <template v-for="(skill, key_skill) in item.employee_skill">
                            {{ skill.skill_lv2[0].name }}
                            <span v-if="key_skill + 1 < item.employee_skill.length ">, </span>
                          </template>
                        </div>
                      </td>
                      <td>
                        <template v-if="item.effortEmployee > 0">
                                <span class="no-free">
                                  {{
                                    $t(
                                      "project.label_resource_situation_status_no_free"
                                    )
                                  }}</span>
                        </template>
                        <template v-else>
                                <span class="free">{{
                                    $t(
                                      "project.label_resource_situation_status_free"
                                    )
                                  }}</span>
                        </template>
                      </td>
                      <td :class="[index === 9 ? 'border-bottom-right' : '']" class="detail">
                        <router-link :to="{ name: 'ResourceDetailLayout',params: { id: item.id } }">
                          {{
                            $t(
                              "project.label_project_action_detail"
                            )
                          }}
                        </router-link>
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td class="text-center" colspan="12" style="border-radius: 10px">
                        {{ $t("table.label_data_not_found") }}
                      </td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </div>
    <Pagination
      :list-item="this.resourceSituations"
      :page="page"
      :totalItems="this.totalResourceSituations"
      @paging="paging"
    />
  </div>
</template>

<script>
import {CChartPie} from "@coreui/vue-chartjs";
import {mapActions, mapGetters} from "vuex";
import {deepObjectsMerge} from "@coreui/utils/src";
import moment from "moment";
import DatePicker from 'vue2-datepicker';
import Pagination from "../../../components/Common/Pagination";

export default {
  name: "ResourceEmployees",
  // metaInfo() {
  //   return {
  //     title: this.$t("bread_crumb.project.resource"),
  //     titleTemplate: "%s | " + this.$t("page_title.head_title")
  //   };
  // },
  components: {
    CChartPie,
    Pagination,
    DatePicker,
  },
  props: {
    searchData: Object
  },
  data() {
    return {
      activeTab: "tab-list",
      // searchData: {
      //   info: "",
      //   footCode: 0,
      //   division: 0,
      //   status: 0,
      //   startDate: '',
      //   endDate: '',
      //   itemsPerPage: 10,
      //   skill: 0,
      // },
      page: 1,
      statusOptions: ['Đang rảnh', 'Đang làm việc'],
      currentDate: [
        new Date(moment().subtract(7, 'd')),
        new Date()
      ],
      footOptions: [{code: 'SOFTWARE_DEVELOPMENT', 'name': 'Khối phát triển số 1'}, {
        code: 'SOFTWARE_DEVELOPMENT_2',
        'name': 'Khối phát triển số 2'
      }],
      fisrtDay: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
      }
    };
  },
  computed: {
    ...mapGetters({
      resourceSituations: "project/listResourceSituations",
      totalResourceSituations: "project/totalResourceSituations",
      skillLv2: "commons/skillLv2",
      footDivision: "commons/footDivision",
    })
  },
  methods: {
    ...mapActions("layout", ["setLoading"]),
    ...mapActions("commons", ["getCommonsData"]),

    async getLists(page) {
      this.setLoading(true);
      await this.$store.dispatch("project/listResourceSituations", {
        status: this.searchData.status,
        footCode: this.searchData.footCode,
        division: this.searchData.division,
        employeeInfo: this.searchData.info.toLowerCase(),
        start_date: this.searchData.startDate,
        end_date: this.searchData.endDate,
        skill: this.searchData.skill,
        activeTab: this.activeTab,
        page: page
      });
      this.setLoading(false);
    },

    async search() {
      this.setLoading(true);
      await this.$store.dispatch("commons/getDivisionByFoot", this.searchData.footCode);

      if (this.footDivision.length === 0 || this.searchData.oldFootCode !== this.searchData.footCode) {
        this.$emit('updateSearchDataDivision', 0)
      }
      this.page = 1;
      let error = '';
      this.$emit('updateSearchDataInfo');
      if (!this.searchData.startDate || !this.searchData.endDate) {
        error = this.$t("popup.label_popup_validate_date_project");
      }
      if (error !== '') {
        this.$toast(
          error,
          null,
          2000,
          "b-toaster-top-center",
          "danger"
        );
        return;
      }
      this.searchData.oldFootCode = this.searchData.footCode;
      try {
        await this.getLists(this.page);
        localStorage.setItem('search_condition', JSON.stringify(this.searchData));
        this.setLoading(false);
      } catch {
        this.setLoading(false);
      }
    },
    resetForm() {
      this.$emit('resetForm', {
        info: "",
        division: 0,
        status: 0,
        skill: 0,
        footCode: 0,
      })
      this.getStartEndDate();
    },

    async paging(value) {
      await this.getLists(value);
      this.page = value;
    },

    checkId() {
      this.$emit('updateSearchDataInfo');
    },

    getStartEndDate() {
      let currentDate = new Date();
      // this.$emit('updateSearchDataDate', {
      //   startDate: moment(currentDate).startOf("isoWeek").format("DD/MM/YYYY"),
      //   endDate: moment(currentDate).startOf("isoWeek").add(6, "day").format("DD/MM/YYYY")
      // });
      this.$emit('updateSearchDataDate', {
        startDate: this.searchData.startDate,
        endDate: this.searchData.endDate,
      });
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
  },
  async created() {
    await this.setLoading(true);
    if (localStorage.getItem('search_condition')) {
      this.$emit('updateSearchData', {
        searchData: JSON.parse(localStorage.getItem('search_condition'))
      })
    }
    await this.getCommonsData();
    await this.getStartEndDate();
    await this.setLoading(false);
    await this.getLists(this.page);
    await this.$store.dispatch("commons/getDivisionByFoot", this.searchData.footCode);
  },
  watch: {
    currentDate(value) {
      this.searchData.startDate = moment(value[0]).format('DD/MM/YYYY');
      this.searchData.endDate = moment(value[1]).format('DD/MM/YYYY');
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.resource-container {
  padding: 0 1rem 1rem 1rem !important;
}

.aside-menu-show {
  background-color: #FFFFFF;
}

.aside-menu {
  margin-left: 0px;
}

.nav-tabs {
  border: none;
  font-size: 1rem;
}

.nav-item {
  color: #858585;
  cursor: pointer;
  padding: 0px;
}

.nav-item.active span {
  color: #032641;
  display: inline-block;
  border-bottom: 2px solid black;
  padding-bottom: 2px;
  font-weight: bold;
}

.form-group {
  margin-bottom: 0;
}

h5 {
  margin: 30px 0;
  font-weight: bold;
}

label {
  color: #385368;
}

.btn-add-new label {
  color: #f6ab5f;
  font-size: 1rem;
  cursor: pointer;
}

.table-list-employee {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 8px;
  text-align: left;

  thead {
    padding: 1em;
    background: #d3edff;

    th {
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      line-height: 17px;
      color: #303c54;
      border-bottom: 1px solid #D3EDFF;
      height: 44px;
      text-align: left;
      padding: 0 10px;

      &:nth-child(1) {
        border-radius: 10px 0 0 10px;
        border-bottom: 0 !important;
      }

      &:nth-child(6) {
        width: 20%;
      }

      &:nth-child(7) {
        width: 130px;
      }

      &:nth-child(8) {
        width: 100px;
      }

      &:nth-child(10) {
        border-radius: 0 10px 10px 0;
        border-bottom: 0 !important;
      }
    }
  }

  tbody {
    padding: 1em;

    td {
      text-align: left;
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
      color: #303c54;
      vertical-align: middle;
      height: 44px;
      border: 1px solid #d3edff;
      border-left: 0;
      border-right: 0;
      padding: 0 10px;

      &:first-child {
        border-left: 1px solid #d3edff;
        border-radius: 10px 0 0 10px;
      }

      &:last-child {
        border-right: 1px solid #d3edff;
        border-radius: 0 10px 10px 0;
      }
    }
  }
}

.card {
  border: none;
  background-color: transparent;
  margin-bottom: 0px;
}

.w-80 {
  width: 80px;
}

.w-95 {
  width: 95px;
}

.table-responsive {
  overflow-x: unset;
}

.no-free {
  color: #17A896;
}

.free {
  color: #F03D3E;
}

.detail {
  color: #3488EB;
}

.nav-item.active span {
  border-bottom: 2px solid #3488EB;
}

.mx-datepicker {
  display: block;
  width: 100%;
}

.overflow-project-detail {
  max-height: 86px;
  overflow: auto;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.overflow-project-detail::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.overflow-project-detail {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.date-input {
  width: 100%;
  height: 35px;
  border: 1px solid #d8dbe0;
  border-radius: 5px;
}

/deep/ .mx-datepicker-range,
.mx-datepicker {
  height: 35px;
  @media screen and (max-width: 600px) {
    width: 100%;
  }

  .mx-input-wrapper {
    height: 35px;
  }

  /deep/ input {
    height: 35px;
  }
}

/deep/ .multiselect__tags {
  height: 35px;
  border: 1px solid #cfcfcf;
}

@media screen and (max-width: 1300px) {
  .aside-menu {
    margin-left: 30px;
  }
}

.card-table-emloyee {
  padding: 30px;
  border: none;
  border-bottom: 1px solid #EFEFEF;
  border-top: 1px solid #EFEFEF;
}

.btn-search-employee {
  background-color: #b5dbf2;
  padding: 8px;
  width: 46%;
}

.btn-reset {
  width: 46%;
  margin-left: 7%;
}

.select-per-page {
  width: 70px;
  margin-bottom: 10px;
}

.option-table {
  display: flex;
  justify-content: space-between;
}

.btn-search {
  margin-bottom: 15px;
}

ul {
  padding: 0;
  margin: 0;
}

li {
  list-style: none;
}

@media screen and (max-width: 767px) {
  .aside-menu {
    margin-left: 0;
  }
  .card {
    border: none;
    background-color: transparent;
  }
  .card-body {
    padding: 0.25rem;
  }
  .card-table-emloyee {
    padding: 0 !important;
  }
  .search-mb-info {
    display: none;
  }
  .show-text-table {
    margin-left: 2.375rem;
  }
  .mb-mobile-2 {
    margin-bottom: 0.5rem;
  }
  .c-main.container-fluid {
    padding: 0px !important;
  }
  .btn-search {
    margin-bottom: 0 !important;
    margin-top: 0 !important;
  }
  .employee-table {
    background-color: #ffffff;
    padding: 10px;
  }
  .table-mobile {
    width: 900px;
    overflow-x: scroll;
  }
  .table-mobile tr {
    border-radius: 5px;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .aside-menu {
    margin-left: 0;
  }
  .p-tablet-0 {
    padding: 0 !important;
  }
}

.container-fluid {
  padding: 0;
}

</style>
